
import * as ReactDOM from 'react-dom';

export const scrollIntoViewIfNecessary = (component: any) => {
  const el = ReactDOM.findDOMNode(component) as Element;
  if (!!el) {
    const rect = el.getBoundingClientRect();
    if (!!window && !!rect && (window.innerHeight < rect.top || rect.top < 0)) {
      el.scrollIntoView();
    }
  }
};
